import * as AppleAuthentication from 'expo-apple-authentication';
import { Link, Stack, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { StyleSheet, withUnistyles } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import Button from '@/components/UI/Button';
import Text from '@/components/UI/Text';
import { MainIcon } from '../../icons/1time';
import { signInWithApple, signInWithGoogle } from './components/SignIn.utils';
import SignInButton from './components/SignInButton';

const ThemedMainIcon = withUnistyles(MainIcon, (theme) => ({
  color: theme.colors.typography,
}));

export default function SignIn() {
  const { invite } = useLocalSearchParams<{ invite?: string }>();
  const [isAppleAvailable, setIsAppleAvailable] = useState(false);
  const emailSignInHref =
    invite === 'true'
      ? { pathname: '/sign-in/email', params: { invite: 'true' } }
      : '/sign-in/email';

  useEffect(() => {
    (async () => {
      const isAvailable = await AppleAuthentication.isAvailableAsync();
      setIsAppleAvailable(isAvailable || Platform.OS === 'web');
    })();
  }, []);

  return (
    <Box style={style.container}>
      <Stack.Screen options={{ title: '' }} />
      <ThemedMainIcon width={135} height={111} />

      <Box alignItems="center" space="md">
        <Box space="md" alignItems="center">
          <SignInButton
            variant="secondary"
            outline
            onPress={signInWithGoogle}
            title="Sign in with Google"
            icon="logo-google"
          />
          {isAppleAvailable && (
            <SignInButton
              variant="secondary"
              outline
              onPress={signInWithApple}
              title="Sign in with Apple"
              icon="logo-apple"
            />
          )}
        </Box>
        <Link href={emailSignInHref} asChild>
          <Button appearance="ghost" style={style.emailButton}>
            <Text size="md">Or Sign in with Email</Text>
          </Button>
        </Link>
      </Box>
    </Box>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    gap: theme.space(4),
  },
  bannerWrapper: {
    alignItems: 'center',
    width: 74,
    height: 90,
  },
  banner: {
    width: 74,
    height: 90,
  },
  emailButton: {
    padding: theme.space(2),
    borderRadius: theme.borderRadius.xl,
  },
}));
